import { render, staticRenderFns } from "./SectionLinkStyle.vue?vue&type=template&id=cbc450dc&"
import script from "./SectionLinkStyle.vue?vue&type=script&lang=js&"
export * from "./SectionLinkStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports